import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import LastdaysTabing from '../../clients/kpis/lastdaysTabing';
import Swal from 'sweetalert2';

import DomainTable from '../../../_components/clients/campaigns/campaignsTable';
import ResponsesTable from '../../../_components/clients/campaigns/ResponsesTable';  
 
import ImageUploading from 'react-images-uploading';
import Popup from "reactjs-popup";

import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.css';

import 'froala-editor/js/plugins.pkgd.min.js';
import Froalaeditor from 'froala-editor'
import FroalaEditor from 'react-froala-wysiwyg';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView'
import { CommonConstants } from "../../../_constants/common.constants";
import { GetUserDetails } from "../../../_helpers/Utility"; 
import axios from 'axios';
import { history } from '../../../_helpers';
import CampaignTemplatingLoading from "../../../images/loading.gif";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));


export default function SimpleTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [popupval,setpopup] = React.useState(false);
  const [GlobalTemplate, SetGlobalTemplate] = React.useState(false);
  const [ClientTemplate, SetClientTemplate] = React.useState(false);
  const [AddPopup, SetAddPopup] = React.useState(false);
  const [ClientID, setClientID] = React.useState(0);
  const [UserID, setUserID] = React.useState(0);
  const [Role, setRole] = React.useState("");
  const [ClientTemplateData, SetClientTemplateData] = React.useState([]);
  const [GlobalTemplateData, SetGlobalTemplateData] = React.useState([]);
  const [CampaignTemplateID, SetCampaignTemplateID] = React.useState("");
  const [IsCampaignTemLoading, SetIsCampaignTemLoading] = React.useState(true)

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [images, setImages] = React.useState([]);
  const maxNumber = 69;

  useEffect(() => {
    document.title = "Campaigns | SalesHive"
    var getaccountcatelist = GetUserDetails();
    if (getaccountcatelist != null) {
      setClientID(getaccountcatelist.ClientID);
      setUserID(getaccountcatelist.ParentUserID);
      setRole(getaccountcatelist.Role);
    }
  }, []);

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  }; 
  const openTermsConditionPopup = () => {
    //console.log("--it's true");
    setpopup(true);
  };

  const closeTermsConditionModal = () => {
    //console.log("--it's false");
    setpopup(false);
  };

  const SubmitTermsConditionModal = () => {
    setpopup(false);
  };


  document.addEventListener('mouseup', function(e) {
      console.log("--popup value--");
      //console.log(popupval);
      if(popupval){
        setpopup(false);
      }
  });
    //const openTermsConditionPopup = false;

    const AddPopupHandle = async () =>{
      if(AddPopup === true){
        SetAddPopup(false);
      }else{
        SetAddPopup(true);
      }
    }  

  const GlobalTemplateHandle = async () =>{
    if(GlobalTemplate === true){
      //document.getElementById(CampaignTemplateID).style.border = "none";
      SetCampaignTemplateID("");
      SetGlobalTemplate(false)
    }else{
      SetGlobalTemplate(true)
      GetCampaignTemplateList("Global")
    }
  }
  
  const ClientTemplateHandle = async () =>{
    if(ClientTemplate === true){
      SetClientTemplate(false)
    }else{
      SetClientTemplate(true)
      GetCampaignTemplateList("Client")
    }
  }

  const GetCampaignTemplateList = async (Page) =>{
    var StrIn = {
      ClientID:ClientID,
      UserID:UserID,
      Role:Role,
      TemplateType:Page
    }
    var ClientCampaignTemplate = await axios({
      url:
        CommonConstants.MOL_APIURL + "/campaigntemplate/GetCampaignTemplate",
      method: "POST",
      data: StrIn,
    });
    console.log(ClientCampaignTemplate, "--->Data")
    if(ClientCampaignTemplate.data.StatusMessage === "SUCCESS"){
      SetGlobalTemplateData(ClientCampaignTemplate.data.Data)
    }
    SetIsCampaignTemLoading(false)
  }
  const DeleteTemplate =  (CampaignTemplateID,Page) =>{
    Swal.fire({
      title: "Are you sure?",
      text: "you want to delete a campaign global template.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34bfa3",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText:"No, cancel!",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        SetIsCampaignTemLoading(true)
        var StrIn = {
          CampaignTemplateID:CampaignTemplateID,
          ClientID:ClientID,
          UserID:UserID,
          Role:Role
        } 
        axios({
          url:
            CommonConstants.MOL_APIURL + "/campaigntemplate/DeleteCampaignTemplate",
          method: "POST",
          data: StrIn,
        }).then((res) => {
          if (res) {
            if ((res.statusText = "Ok")) {
              Swal.fire(
                "Deleted!",
                "Campaign global template deleted successfully.",
                "success"
              );
              GetCampaignTemplateList(Page)
              SetCampaignTemplateID("")
              SetIsCampaignTemLoading(false)
            } else {
            }
          }
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your data is safe :)", "error");
      }
    });
  };
  // const DeleteTemplate = async (CampaignTemplateID,Page) =>{
  //   console.log(CampaignTemplateID)
  //   var StrIn = {
  //     CampaignTemplateID:CampaignTemplateID,
  //     ClientID:ClientID,
  //     UserID:UserID,
  //     Role:Role
  //   }
  //   var ClientCampaignTemplate = await axios({
  //     url:
  //       CommonConstants.MOL_APIURL + "/campaigntemplate/DeleteCampaignTemplate",
  //     method: "POST",
  //     data: StrIn,
  //   });
  //   console.log(ClientCampaignTemplate, "--->Data")
  //   if(ClientCampaignTemplate.data.StatusMessage === "SUCCESS"){
      
  //       GetCampaignTemplateList(Page)
  //       SetCampaignTemplateID("")
  //   }
  // }

  const SelectedCampaignTemplate = async (TemplateID) => {
    if(CampaignTemplateID === ""){
      document.getElementById(TemplateID).style.border = "1px solid skyblue";
      SetCampaignTemplateID(TemplateID)
    }else{
    document.getElementById(TemplateID).style.border = "1px solid skyblue";
    document.getElementById(CampaignTemplateID).style.border = "none";
    SetCampaignTemplateID(TemplateID)
    }
  }

  const GlobalTemplateCreate = async () =>{
    if(CampaignTemplateID != ""){
      console.log(CampaignTemplateID)
      history.push({ pathname: "/caddcampaigns", state: { data: CampaignTemplateID } });
    }
  }
  

  return (
    <div className="tabdes"> 
                {
          IsCampaignTemLoading === true ? <div id="hideloding" className="loding-display">
        <img src={CampaignTemplatingLoading} />
      </div> : null
        }
      <div> 
        <AppBar position="static">
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example"> 
            <Tab label="Campaigns" {...a11yProps(0)}>Overviewasdasd</Tab>
            <Tab label="Responses" {...a11yProps(1)} /> 
          </Tabs>
        </AppBar>
      
        <TabPanel value={value} className="tagpaddnone bg-white" index={0}>

            <div className="row">
              <div className="col border-bottom">
                  <h4 className="headertitle float-left pt-0 pl-0">Campaigns</h4>   
              </div> 
              <div className="col border-bottom px-5">
                  <div className="listing-li float-right padb-15">
                       
                  </div>
              </div>
            </div>

            <div className="row">
              <div className="col border-bottom"> 
              </div> 
              <div className="col border-bottom px-4">
                  <div className="listing-li float-right padb-15"> 
                      <ul>
                      <li onClick={AddPopupHandle}>
                        <a className="btn btngroup m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air">
                                <i class="la la-plus la-icon-font-size-13"></i>
                                <span>Add</span>
                            </a> 
                          <Popup open={AddPopup}>
                              <div>
                            <div className="modal-black"></div>
                              <div className="filterPopup maxpopupfull">
                                <div className="paddingboxTerms">
                                  <div className="modal-header py-4 px-3">
                                    <div className='w-100 d-flex px-3'>
                                        <h5 className="mb-0">Create a campaign</h5>
                                        <button className="close" onClick={AddPopupHandle}>
                                          <span aria-hidden="true" class="la la-remove"></span>
                                        </button>
                                    </div> 
                                  </div> 
                                  <div className="modal-body"> 
                                    <div className="px-4">    
                                      <div className="row padt-25">
                                          <div className='col-lg-4 text-center clercolum'>
                                            <i class="flaticon-list clr-purple f-50"></i>
                                              <button class="btn btn-md btngroup mt-2 mb-3" onClick={GlobalTemplateHandle}>
                                                      From global template
                                                    </button> 
                                                <Popup open={GlobalTemplate}>
                                                      <div>
                                                    <div className="modal-black"></div>
                                                      <div className="filterPopup maxpopupfull">
                                                        <div className="modal-header py-4 px-3">
                                                          <div className='w-100 d-flex px-3'>
                                                              <h5 className="mb-0">Select a campaign global template</h5>
                                                              <button className="close" onClick={GlobalTemplateHandle}>
                                                                <span aria-hidden="true" class="la la-remove"></span>
                                                              </button>
                                                          </div> 
                                                        </div> 

                                                        <div className="paddingboxTerms"> 
                                                          <div className="modal-body cardtempls"> 
                                                          {GlobalTemplateData?.map((row)=>{
                                                               return (
                                                                <a onClick={()=>SelectedCampaignTemplate(row._id)}>
                                                                <div className='row'>
                                                               <div id = {row._id} className='card col-lg-12 mb-3'>
                                                                 <div className=''>
                                                                     <h5>{row.Name}</h5>
                                                                     <a onClick={()=>{DeleteTemplate(row._id,"Global")}} class="rightdeleted" title="Delete">
                                                                       <i class="la flaticon-delete-1 delete-icon"></i>
                                                                     </a>
                                                                   </div>
                                                                   <p>{row.Notes}</p>
                                                               </div>
                                                             </div>
                                                             </a>
                                                               )
                                                            })}
                                                              

                                                          </div>   
                                                        </div>

                                                        <div class="modal-footer">
                                                            <button type="button" class="btn btn-secondary" data-dismiss="modal" onClick={GlobalTemplateHandle}>Cancel</button>
                                                            <button id="lnkCreateCampaignFromTemplate" class="btn btn-primary btngroup" onClick={GlobalTemplateCreate}><i class="la la-save"></i> Create</button>
                                                        </div>

                                                      </div>
                                                    </div>
                                                </Popup>

                                            <p>Create a campaign from a global template.</p>
                                          </div>
                                          <div className='col-lg-4 text-center clercolum'>
                                            <i class="flaticon-list clr-purple f-50"></i>
                                            <button class="btn btn-md btngroup mt-2 mb-3" onClick={ClientTemplateHandle}>
                                                      From template
                                                    </button> 
                                            <Popup open={ClientTemplate}>
                                                      <div>
                                                    <div className="modal-black"></div>
                                                      <div className="filterPopup maxpopupfull">
                                                        <div className="modal-header py-4 px-3">
                                                          <div className='w-100 d-flex px-3'>
                                                              <h5 className="mb-0">Select a campaign form template</h5>
                                                              <button className="close" onClick={ClientTemplateHandle}>
                                                                <span aria-hidden="true" class="la la-remove"></span>
                                                              </button>
                                                          </div> 
                                                        </div> 

                                                        <div className="paddingboxTerms"> 
                                                          <div className="modal-body cardtempls">
                                                            {GlobalTemplateData?.map((row)=>{
                                                               return (
                                                                <a onClick={()=>SelectedCampaignTemplate(row._id)}>
                                                                <div className='row'>
                                                               <div id = {row._id} className='card col-lg-12 mb-3'>
                                                                 <div className=''>
                                                                     <h5>{row.Name}</h5>
                                                                     <a onClick={()=>{DeleteTemplate(row._id,"Client")}} class="rightdeleted" title="Delete">
                                                                       <i class="la flaticon-delete-1 delete-icon"></i>
                                                                     </a>
                                                                   </div>
                                                                   <p>{row.Notes}</p>
                                                               </div>
                                                             </div>
                                                             </a>
                                                               )
                                                            })}
                                                             

                                                              {/* <div className='row'>
                                                                <div className='card col-lg-12 mb-3'>
                                                                  <div className=''>
                                                                      <h5>09-10-Dev Test - Template</h5>
                                                                      <a href="javascript:void(0);" class="rightdeleted" title="Delete">
                                                                        <i class="la flaticon-delete-1 delete-icon"></i>
                                                                      </a>
                                                                    </div>
                                                                    <p>Testing purpose</p>
                                                                </div>
                                                              </div>

                                                              <div className='row'>
                                                                <div className='card col-lg-12 mb-3'>
                                                                  <div className=''>
                                                                      <h5>09-10-Dev Test - Template</h5>
                                                                      <a href="javascript:void(0);" class="rightdeleted" title="Delete">
                                                                        <i class="la flaticon-delete-1 delete-icon"></i>
                                                                      </a>
                                                                    </div>
                                                                    <p>Testing purpose</p>
                                                                </div>
                                                              </div>                                                               */}

                                                          </div>   
                                                        </div>

                                                        <div class="modal-footer">
                                                            <button type="button" class="btn btn-secondary" onClick={ClientTemplateHandle} data-dismiss="modal">Cancel</button>
                                                            <a id="lnkCreateCampaignFromTemplate" onClick={GlobalTemplateCreate} class="btn btn-primary btngroup"><i class="la la-save"></i> Create</a>
                                                        </div>
                                                        
                                                      </div>
                                                    </div>
                                                </Popup>
                                            <p>Create a campaign from a template.</p>
                                          </div>
                                          <div className='col-lg-4 text-center clercolum'>
                                            <i class="flaticon-file-1 clr-purple f-50"></i>
                                            <a href='/caddcampaigns' class="btn btn-md btngroup mt-2 mb-3">
                                            From scratch
                                            </a>
                                            <p>Create a campaign from the scratch. Specify steps, emails templates, and add people.</p>
                                          </div>
                                      </div> 
 
                                    </div> 
                                  </div>   
                                </div>
                              </div>
                            </div>
                        </Popup>

                          </li>
                          <li>
                          <a href="" className="btn btngroup m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air">
                              <i class="la la-icon-font-size-13 la-download"></i>
                              <span>Export</span>
                          </a>
                          </li>
                      </ul>
                  </div>
              </div>
            </div> 
            <div className="row">
            <div className="col">
                <DomainTable />
            </div>
          </div> 
        </TabPanel>
        <TabPanel value={value} className="tagpaddnone bg-white" index={1}>

            <div className="row">
            <div className="col">
                <ResponsesTable />
            </div>
          </div> 
        </TabPanel>
 
      </div> 

    </div>
  );
}